/**
 * The HR module's strings (piece 34), kept beside its rules and spread into
 * the one lookup in `strings.ts`, so `t()` stays the only way a screen reads
 * text. 🔨 This file imports nothing, because the lookup imports it.
 */
export const HR_STRINGS = {
  'whatsNew.area.hr': 'HR',
  'hr.employees.title': 'Employees',
  'hr.employees.subtitle': 'Everyone employed by the organization today, with a login or without one',
  'hr.employees.empty': 'Nobody holds an active employment at the organization’s own company.',
  'hr.employees.col.name': 'Name',
  'hr.employees.col.title': 'Position',
  'hr.employees.col.department': 'Department',
  'hr.employees.col.startDate': 'Start Date',
  'hr.nav.label': 'HR pages',
  // Decision 3180: the employee file and My Info.
  'hr.file.subtitle': 'One job’s employee file, read by HR and by the managers above this person',
  'hr.file.notFound': 'No job at the organization’s own company was found by that address.',
  'hr.file.readOnlyChain': 'You are reading this file as a manager above this person, so nothing on it can be changed here.',
  'hr.file.former': 'This job has ended. The file is kept as it stood and reads as it stood.',
  'hr.file.section.job': 'Job',
  'hr.file.section.pay': 'Pay',
  'hr.file.section.place': 'Place',
  'hr.file.section.access': 'Access',
  'hr.file.section.time': 'Time',
  'hr.file.section.trainings': 'Trainings and Certifications',
  'hr.file.section.custody': 'Custody',
  'hr.file.section.emergency': 'Emergency',
  'hr.file.section.reviews': 'Reviews',
  'hr.file.section.attendance': 'Attendance',
  'hr.file.untitled': 'Position',
  'hr.file.reportsTo': 'reports to',
  'hr.file.fullTime': 'full time',
  'hr.file.partTime': 'part time',
  'hr.file.hourly': 'hourly',
  'hr.file.salaried': 'salaried',
  'hr.file.exempt': 'exempt',
  'hr.file.nonExempt': 'non-exempt',
  'hr.file.current': 'Current',
  'hr.file.ended': 'Ended',
  'hr.file.perHour': 'per hour',
  'hr.file.perYear': 'per year',
  'hr.file.hoursPerPeriod': 'hours a pay period',
  'hr.file.approvedBy': 'approved by',
  'hr.file.rejectedBy': 'rejected by',
  'hr.file.enteredBy': 'entered by',
  'hr.file.payPending': 'Waiting for Approval',
  'hr.file.payRejected': 'Rejected',
  'hr.file.workSite': 'Work Site',
  'hr.file.startsLater': 'Starts Later',
  // 🔨 T2348: a work site in a state with no employment rules on file is refused in plain words; {state} is the state code.
  // 🔒 Decision 6841 (T3003): the sentence names the page the rules are added on, and the Hire window and Edit Employee link to it.
  'hr.site.noRules': 'No employment rules are set up for {state}, so a work site there cannot be used yet. An administrator adds them on Settings › HR › Employment Rules.',
  'hr.site.rulesPage': 'Settings › HR › Employment Rules',
  'hr.site.openRules': 'Open Employment Rules',
  // 🔒 Decision 6842 (T3003): the First hire guide above the Hire window.
  'hr.firstHire.title': 'First Hire',
  'hr.firstHire.hint': 'A hire at our own company needs these four first. Each step reads done from what is already on file, and the guide goes once all four are done.',
  'hr.firstHire.domain.title': 'The company’s email domain is registered',
  'hr.firstHire.domain.body': 'The work email a hire is given is checked against the domains registered for the company, and a fresh install holds only localhost.',
  'hr.firstHire.domain.done': 'Registered:',
  'hr.firstHire.domain.none': 'Only localhost is registered.',
  'hr.firstHire.domain.open': 'Open Email Domains',
  'hr.firstHire.site.title': 'A site of our own is on file',
  'hr.firstHire.site.body': 'A hire works out of one of our own company’s sites, which sets the state whose employment rules apply.',
  'hr.firstHire.site.done': 'Sites of ours:',
  'hr.firstHire.site.none': 'Our own company has no site yet.',
  'hr.firstHire.site.open': 'Open Our Company',
  'hr.firstHire.jobRole.title': 'A job role is active',
  'hr.firstHire.jobRole.body': 'The Job section asks a job role, which carries the duties and the workers’ compensation class code.',
  'hr.firstHire.jobRole.done': 'Active job roles:',
  'hr.firstHire.jobRole.none': 'No job role is active.',
  'hr.firstHire.jobRole.open': 'Open Job Roles',
  'hr.firstHire.rules.title': 'Each site’s state has employment rules',
  'hr.firstHire.rules.body': 'A work site in a state with no employment rules on file cannot be hired into.',
  'hr.firstHire.rules.done': 'Every site of ours has its state’s rules.',
  'hr.firstHire.rules.missing': 'No rules yet for:',
  'hr.firstHire.rules.noState': 'A site of ours has no state in its address.',
  'hr.firstHire.rules.open': 'Open Employment Rules',
  'hr.firstHire.waitsSite': 'Waits for a site of our own.',
  'hr.file.homeAddress': 'Home Address',
  'hr.file.login': 'Login',
  'hr.file.noLogin': 'No login: this person signs in to nothing and may still punch a clock.',
  'hr.file.lastSignedIn': 'last signed in',
  'hr.file.timeEntries': 'Time Entries',
  'hr.file.clockCredentials': 'Clock Credential History',
  'hr.file.hours': 'hours',
  'hr.file.active': 'Active',
  'hr.file.revoked': 'Revoked',
  'hr.file.expires': 'expires',
  'hr.file.started': 'Started',
  'hr.file.none': 'None yet',
  'myInfo.title': 'My Info',
  'myInfo.subtitle': 'Your own employee file: your job, pay, trainings and time, read-only',
  'myInfo.none': 'You hold no job at the organization today, so there is no employee file to show.',
  'hr.nav.employees': 'Employees',
  // Decision 3181: the Hire window, Edit Employee, Former Employees and Job Roles.
  'hr.employees.view.current': 'Employees',
  'hr.employees.view.former': 'Former Employees',
  'hr.employees.col.endDate': 'Last Day',
  'hr.employees.formerEmpty': 'Nobody has left a job at the organization’s own company.',
  'hr.hire.button': '+ Hire',
  'hr.hire.title': 'Hire',
  'hr.hire.act': 'Hire',
  'hr.hire.payrollFirst': 'Enter the hire in the payroll service first. The payroll service emails the new hire for the Social Security number and the tax forms; this window never asks for them.',
  'hr.hire.section.person': 'Person',
  'hr.hire.section.job': 'Job',
  'hr.hire.section.place': 'Place',
  'hr.hire.section.pay': 'Pay',
  'hr.hire.section.access': 'Access',
  'hr.hire.firstName': 'First Name',
  'hr.hire.lastName': 'Last Name',
  'hr.hire.matchesLead': 'Already on file under that name:',
  'hr.hire.noMatches': 'Nobody is on file under that name.',
  'hr.hire.usePerson': 'Hire This Person',
  'hr.hire.newPerson': 'No, This Is a New Person',
  'hr.hire.newPersonChosen': 'A new person, after the matches shown were set aside:',
  'hr.hire.matchChosen': 'Hiring the person on file:',
  'hr.hire.changePerson': 'Change',
  'hr.hire.startDate': 'First Day',
  'hr.hire.jobTitle': 'Title',
  'hr.hire.jobRole': 'Job Role',
  'hr.hire.department': 'Department',
  'hr.hire.manager': 'Manager',
  'hr.hire.managerDerived': 'The Department’s Head',
  'hr.hire.level': 'Level',
  'hr.hire.noLevel': 'No Level',
  'hr.hire.schedule': 'Schedule',
  'hr.hire.basis': 'Pay Basis',
  'hr.hire.overtime': 'Overtime Class',
  'hr.hire.workSite': 'Work Site',
  'hr.hire.workEmail': 'Work Email',
  'hr.emergency.private': 'Kept Private',
  'hr.emergency.none': 'No emergency contact is named yet.',
  'hr.emergency.behindReason': 'Reading these contacts asks a reason first, which is kept and sent to HR.',
  'hr.emergency.readButton': 'Read Emergency Contacts',
  'hr.emergency.reasonTitle': 'Read Emergency Contacts',
  'hr.emergency.reasonAct': 'Read Contacts',
  'hr.emergency.reasonLead': 'Say why you need these contacts. HR is told of this read, with your reason and the time.',
  'hr.emergency.reason': 'Reason',
  'hr.emergency.editTitle': 'Emergency Contacts',
  'hr.emergency.editAct': 'Save Contacts',
  'hr.emergency.editLead': 'Name one or two people to call if something happens to you at work. HR and your managers can read them.',
  'hr.emergency.first': 'First Contact',
  'hr.emergency.second': 'Second Contact',
  'hr.emergency.name': 'Name',
  'hr.emergency.relationship': 'Relationship',
  'hr.emergency.phone': 'Phone',
  'hr.emergency.add': 'Add Second Contact',
  'hr.emergency.remove': 'Remove Second Contact',
  'hr.emergency.addFirst': 'Add Emergency Contacts',
  'hr.emergency.editButton': 'Edit Emergency Contacts',
  'hr.reviews.file': 'File Signed Review',
  'hr.reviews.open': 'Open',
  'hr.reviews.filed': 'The signed review is filed on this job.',
  'hr.reviews.hint': 'File the review once it is signed. It is kept on this job as an HR document.',
  'hr.reviews.filedBy': 'filed by',
  // Decision 12850 (T3854): the working pattern, drawn in the Job section and read by Who Can Go and the Schedule.
  'hr.pattern.heading': 'Working Pattern',
  'hr.pattern.none': 'No day worked',
  'hr.pattern.readNote': 'Who Can Go and the Schedule read the other days and hours as unavailable',
  'hr.pattern.edit': 'Edit Working Pattern',
  'hr.pattern.title': 'Edit Working Pattern',
  'hr.pattern.act': 'Save Pattern',
  'hr.pattern.lead': 'Who Can Go and the Schedule warn when a booking falls outside these hours. Nothing is refused, and neither shows the hours.',
  'hr.pattern.effectiveFrom': 'Starts On',
  'hr.pattern.worked': 'Worked',
  'hr.pattern.starts': 'Starts',
  'hr.pattern.ends': 'Ends',
  'hr.pattern.saved': 'The working pattern is saved and the earlier one is kept as history.',
  'hr.pattern.outsideChip': 'Outside Their Working Pattern',
  'hr.pattern.outsideNotice': '{name} is outside their working pattern then, and the booking stands.',
  // Decision 12851 (T3857): attendance events, recorded at time approval and listed on the Employee page.
  'hr.attendance.kind.late': 'Late',
  'hr.attendance.kind.noShow': 'No Show',
  'hr.attendance.kind.callOff': 'Call-Off',
  'hr.attendance.minutes': '{minutes} minutes',
  'hr.attendance.recordedBy': 'recorded at approval by {name}',
  'hr.attendance.record': 'Record Attendance',
  'hr.attendance.title': 'Record Attendance',
  'hr.attendance.act': 'Record Event',
  'hr.attendance.lead': 'The event is kept on this person’s file as it is written. A correction is a new event, and this one stays.',
  'hr.attendance.kind': 'What Happened',
  'hr.attendance.minutesLate': 'Minutes Late',
  'hr.attendance.reason': 'Reason',
  'hr.attendance.reasonHint': 'In your own words, as you would say it.',
  // Decision 12930 (T3855): the employee's answer to a manager's correction of their time.
  'hr.timeCorrection.title': 'Corrections To Your Time',
  'hr.timeCorrection.line': '{date} · {before} hours became {after} hours ({change}) · corrected by {name}',
  'hr.timeCorrection.fewer': 'hours fewer',
  'hr.timeCorrection.more': 'hours more',
  'hr.timeCorrection.hourFewer': 'hour fewer',
  'hr.timeCorrection.hourMore': 'hour more',
  'hr.timeCorrection.agree': 'Agree',
  'hr.timeCorrection.dispute': 'Dispute',
  'hr.timeCorrection.unanswered': 'Not answered yet.',
  'hr.timeCorrection.agreed': 'You agreed on {when}.',
  'hr.timeCorrection.disputed': 'You disputed this on {when}: {reason}',
  'hr.timeCorrection.agreedBy': 'Agreed on {when}.',
  'hr.timeCorrection.disputedBy': 'Disputed on {when}: {reason}',
  'hr.timeCorrection.reasonLabel': 'Why You Dispute It',
  'hr.timeCorrection.reasonHint': 'In your own words. Your hours do not change; the approver is told.',
  'hr.timeCorrection.send': 'Send Dispute',
  'hr.timeCorrection.cancel': 'Cancel',
  'hr.timeCorrection.answered': 'Your answer is kept on the correction.',
  'hr.timeCorrection.todoTitle': '{name} disputed a correction to their time',
  'hr.timeCorrection.todoDescription': 'The correction to their time on {date} was disputed: {reason}',
  'hr.attendance.recorded': 'The attendance event is recorded on {name}’s file.',
  'hr.credentials.none': 'No clock credential is active on this job.',
  'hr.credentials.issued': 'Issued',
  'hr.credentials.revoke': 'Revoke',
  'hr.credentials.issuePin': 'Issue PIN',
  'hr.credentials.issueNewPin': 'Issue New PIN',
  'hr.credentials.registerBadge': 'Register Badge',
  'hr.credentials.pinLabel': 'New PIN',
  'hr.credentials.pinShown': 'Give this PIN to the employee now. It is not shown again, and a new PIN replaces the old one.',
  'hr.credentials.done': 'Done',
  'hr.credentials.badgeTitle': 'Register Badge',
  'hr.credentials.badgeAct': 'Register Badge',
  'hr.credentials.badgeNumber': 'Badge Number',
  'hr.credentials.badgeLead': 'Type or scan the number printed on the badge. It is kept only as a hash, so it cannot be read back.',
  'hr.home.hint': 'The home address is private to HR, Admin and the employee, and never joins the Locations list.',
  'hr.home.line1': 'Street Address',
  'hr.home.line2': 'Address Line 2',
  'hr.home.locality': 'City',
  'hr.home.administrativeArea': 'State',
  'hr.home.postalCode': 'Postal Code',
  'hr.home.countryCode': 'Country',
  'hr.home.button': 'Edit Home Address',
  'hr.home.title': 'Edit Home Address',
  'hr.home.act': 'Save Home Address',
  'hr.home.lead': 'The address payroll prints on pay stubs and tax forms. HR, Admin and the employee read it, and a manager does not.',
  'hr.hire.payRate': 'Pay Rate',
  'hr.hire.payRateUnit': 'Per',
  'hr.hire.hoursPerPeriod': 'Hours a Pay Period',
  'hr.hire.login': 'Login Invitation',
  'hr.hire.login.none': 'No Login',
  'hr.hire.login.workEmail': 'Send to the Work Email',
  'hr.hire.login.personalEmail': 'Send to a Personal Address',
  'hr.hire.loginDestination': 'Personal Email',
  'hr.hire.login.mobile': 'Send a Code by Text',
  'hr.hire.login.inPerson': 'Hand Over a Code in Person',
  'hr.hire.login.temporaryPassword': 'Hand Over a Temporary Password',
  'hr.hire.loginMobile': 'Mobile Number',
  'hr.hire.loginHandOver': 'The code or the password is shown to you once, after the hire is saved, to hand over yourself.',
  'hr.hire.loginRole': 'The login reads nothing until an administrator gives it a role on Settings › People › Logins.',
  'hr.hire.choose': 'Choose',
  'hr.edit.button': 'Edit Employee',
  'hr.edit.title': 'Edit Employee',
  'hr.edit.act': 'Save Changes',
  'hr.edit.effectiveOn': 'Takes Effect On',
  'hr.edit.lead': 'A change closes the position in force the day before and opens a dated one, so the old row stands. A new work site is a change like any other. Pay and access are changed elsewhere.',
  'hr.pay.button': 'Change Pay',
  'hr.pay.title': 'Change Pay',
  'hr.pay.act': 'Send for Approval',
  'hr.pay.payrollFirst': 'Enter the raise in the payroll service first, then here. A second holder of the hire permission approves it on this page, and the rate in force stays until then.',
  'hr.pay.effectiveFrom': 'Starts On',
  'hr.pay.reason': 'Reason',
  'hr.pay.waiting': 'A pay change waits for a second holder of the hire permission to approve or reject it.',
  'hr.pay.approve': 'Approve Pay Change',
  'hr.pay.reject': 'Reject Pay Change',
  'hr.pay.rejectTitle': 'Reject Pay Change',
  'hr.pay.rejectAct': 'Reject',
  'hr.pay.rejectReason': 'Why',
  'hr.pay.rejectLead': 'The change stays on the page as Rejected, with the reason, and the rate in force does not move.',
  'hr.schedule.fullTime': 'Full Time',
  'hr.schedule.partTime': 'Part Time',
  'hr.basis.hourly': 'Hourly',
  'hr.basis.salaried': 'Salaried',
  'hr.overtime.nonExempt': 'Non-Exempt',
  'hr.overtime.exempt': 'Exempt',
  'hr.payUnit.perHour': 'Hour',
  'hr.payUnit.perYear': 'Year',
  'settings.jobRoles.title': 'Job Roles',
  'settings.jobRoles.hint': 'The roles the Hire window offers. Each carries the duties an insurance audit is read against and the workers’ compensation class code; a role with no class code is a gap to fill.',
  'settings.jobRoles.add': '+ Add Job Role',
  'settings.jobRoles.addTitle': 'Add Job Role',
  'settings.jobRoles.editTitle': 'Edit Job Role',
  'settings.jobRoles.code': 'Code',
  'settings.jobRoles.name': 'Name',
  'settings.jobRoles.duties': 'Duties',
  'settings.jobRoles.classCode': 'Class Code',
  'settings.jobRoles.gap': 'No class code yet',
  'settings.jobRoles.fieldWork': 'Field Work',
  'settings.jobRoles.positions': 'positions',
  'settings.jobRoles.inactive': 'inactive',
  'settings.employmentRules.title': 'Employment Rules',
  'settings.employmentRules.hint': 'The employment rules of each state our sites are in: overtime, breaks, final pay, sick leave and the rest. A work site in a state with no rules here cannot be hired into. A rule that changes is a new row from the day it takes effect.',
  'settings.employmentRules.add': '+ Add Employment Rules',
  'settings.employmentRules.addTitle': 'Add Employment Rules',
  'settings.employmentRules.editTitle': 'Edit Employment Rules',
  'settings.employmentRules.empty': 'No state has employment rules yet, so no work site can be hired into.',
  'settings.employmentRules.from': 'from',
  'settings.employmentRules.weeklyAfter': 'weekly overtime after',
  'settings.employmentRules.hours': 'hours',
  'settings.employmentRules.section.place': 'State and Date',
  'settings.employmentRules.section.overtime': 'Overtime',
  'settings.employmentRules.section.breaks': 'Breaks',
  'settings.employmentRules.section.finalPay': 'Final Pay',
  'settings.employmentRules.section.leave': 'Leave and Notices',
  'settings.employmentRules.stateCode': 'State Code (two letters)',
  'settings.employmentRules.locality': 'Locality (blank for the whole state)',
  'settings.employmentRules.effectiveFrom': 'Effective From',
  'settings.employmentRules.weeklyOvertime': 'Weekly Overtime After (hours)',
  'settings.employmentRules.dailyOvertime': 'Daily Overtime After (hours)',
  'settings.employmentRules.doubleTime': 'Double Time After (hours)',
  'settings.employmentRules.seventhDay': 'Seventh-Day Rule',
  'settings.employmentRules.seventhDay.none': 'None',
  'settings.employmentRules.seventhDay.seventhConsecutiveDay': 'Seventh Consecutive Day',
  'settings.employmentRules.waiver': 'Overtime Waiver Permitted',
  'settings.employmentRules.mealAfter': 'Meal Break After (hours)',
  'settings.employmentRules.mealMinutes': 'Meal Break Length (minutes)',
  'settings.employmentRules.restPer': 'Rest Break (minutes per hour worked)',
  'settings.employmentRules.attestation': 'Break Attestation at Clock-Out',
  'settings.employmentRules.dischargeRule': 'Final Pay After a Discharge',
  'settings.employmentRules.dischargeDays': 'Discharge Final Pay Within (days)',
  'settings.employmentRules.resignationRule': 'Final Pay After a Resignation',
  'settings.employmentRules.resignationDays': 'Resignation Final Pay Within (days)',
  'settings.employmentRules.finalPay.nextRegularPayday': 'Next Regular Payday',
  'settings.employmentRules.finalPay.lastDayWorked': 'Last Day Worked',
  'settings.employmentRules.finalPay.withinDays': 'Within Days',
  'settings.employmentRules.sickLeave': 'Paid Sick Leave Mandated',
  'settings.employmentRules.leaveNote': 'Leave Mandate Note',
  'settings.employmentRules.unemploymentDays': 'Unemployment Response (days)',
  'settings.employmentRules.drugTesting': 'Drug-Testing Constraints',
  'settings.employmentRules.postings': 'Required Postings',
  'hr.nav.complaints': 'Complaints',
  'hr.complaint.title': 'Complaints',
  'hr.complaint.subtitle': 'Complaints raised by employees, taken, investigated and closed by HR',
  'hr.complaint.empty': 'No complaint you can see has been raised.',
  'hr.complaint.hintWorks': 'Open a complaint to take the investigation, record what was found and what was done, and close it. A manager above the person who raised one never sees it here, and nor does the person it is about.',
  'hr.complaint.hintMine': 'The complaints you raised, with where each one stands. HR takes, investigates and closes them.',
  'hr.complaint.col.raised': 'Raised',
  'hr.complaint.col.raisedBy': 'Raised By',
  'hr.complaint.col.about': 'About',
  'hr.complaint.col.status': 'Status',
  'hr.complaint.col.investigator': 'Investigator',
  'hr.complaint.status.open': 'Open',
  'hr.complaint.status.underInvestigation': 'Under investigation',
  'hr.complaint.status.closed': 'Closed',
  'hr.complaint.recordTitle': 'Complaint',
  'hr.complaint.take': 'Take the Investigation',
  'hr.complaint.taken': 'You are investigating this complaint.',
  'hr.complaint.findings': 'Findings',
  'hr.complaint.actionTaken': 'Action taken',
  'hr.complaint.saveFindings': 'Save Findings',
  'hr.complaint.findingsSaved': 'The findings are saved.',
  'hr.complaint.close': 'Close Complaint',
  'hr.complaint.closedNotice': 'The complaint is closed.',
  'hr.complaint.done': 'Close',
  'hr.complaint.raise': 'Raise a Complaint',
  'hr.complaint.raiseTitle': 'Raise a Complaint',
  'hr.complaint.raiseHint': 'Your complaint goes to HR. The person it is about, your manager and anybody above them never see it. Say what happened in your own words.',
  'hr.complaint.about': 'About',
  'hr.complaint.aboutNobody': 'Nobody in particular',
  'hr.complaint.summary': 'What happened',
  'hr.complaint.raiseSubmit': 'Raise Complaint',
  'hr.complaint.raised': 'Your complaint is with HR.',
  'hr.complaint.yours': 'See your complaints',
  'hr.complaint.routeLead': 'The person this complaint is about reads complaints in this system, as HR or as an administrator, so it is not kept here. Take it to this outside contact instead:',
  'hr.complaint.routeBlank': 'No outside contact is named on Settings › HR yet, so the system has nowhere to send this complaint.',
  'hr.complaint.routeKept': 'Nothing you were about to write has been kept. The system records only that this contact was shown, and when.',
  'hr.nav.certifications': 'Certification Register',
  'hr.cert.title': 'Certification Register',
  'hr.cert.subtitle': 'Every employee’s certifications: what lapses soon, and what is required and not held',
  'hr.cert.col.person': 'Person',
  'hr.cert.col.requirement': 'Requirement',
  'hr.cert.col.expiresOn': 'Lapses On',
  'hr.cert.col.daysLeft': 'Days Left',
  'hr.cert.col.requiredBy': 'Required By',
  'hr.cert.expiring.title': 'Expiring soon',
  'hr.cert.expiring.hint': 'Certifications lapsing within {n} days, soonest first. The lead time is set on Settings › HR › HR Day Counts, and each one raises a renewal to-do for its holder.',
  'hr.cert.expiring.empty': 'Nothing lapses within the lead time.',
  'hr.cert.missing.title': 'Missing coverage',
  'hr.cert.missing.hint': 'Training a department or a job role requires that the person holds no current completion of. Each one raises a to-do for its holder.',
  'hr.cert.missing.empty': 'Everybody holds what their department and job role require.',
  'hr.cert.required.title': 'Required training',
  'hr.cert.required.hint': 'One requirement asked of everybody in one department, or of everybody in one job role. A row names one or the other, never both.',
  'hr.cert.required.empty': 'No training is required of anybody yet.',
  'hr.cert.required.readOnly': 'Adding or deactivating a required training is open to a holder of the hire permission.',
  'hr.cert.required.requirement': 'Requirement',
  'hr.cert.required.choose': 'Choose a requirement',
  'hr.cert.required.department': 'Department',
  'hr.cert.required.jobRole': 'Job role',
  'hr.cert.required.none': 'None',
  'hr.cert.required.add': 'Add Requirement',
  'hr.cert.required.added': 'The requirement is added.',
  'hr.cert.required.deactivate': 'Deactivate',
  'hr.cert.required.deactivated': 'The requirement is deactivated',
  'settings.hr.route.title': 'External Escalation Route',
  'settings.hr.route.shown': 'This contact is shown on the Raise a complaint window to anybody raising a complaint about somebody who reads complaints here, as HR or as an administrator, and the employee handbook prints it. Leave it blank until an outside contact is actually retained.',
  'settings.hr.route.field': 'Outside contact',
  'settings.hr.route.hint': 'Employment counsel or an outside HR service: a name, how to reach them, and anything a person needs to know before calling.',
  'settings.hr.retention.title': 'HR Document Retention',
  'settings.hr.retention.hint': 'How many years HR documents are kept after somebody leaves. For now the number is only recorded: nothing is removed at any age until automatic removal is built.',
  'settings.hr.retention.field': 'Years after the employment ends',
  'settings.hr.days.title': 'HR Day Counts',
  'settings.hr.workCalendar.title': 'Work Calendar',
  'settings.hr.clockDevices.title': 'Clock devices',
  'settings.hr.clockDevices.hint': 'A site that runs gate sign-in takes an entry only on a device registered here. Retiring a device stops it taking entries; the entries it already recorded keep naming it.',
  'settings.hr.clockDevices.none': 'No clock device is registered yet.',
  'settings.hr.clockDevices.register': 'Register Device',
  'settings.hr.clockDevices.registerTitle': 'Register a Clock Device',
  'settings.hr.clockDevices.registered': 'The device is registered. The gate at its site takes entries on it now.',
  'settings.hr.clockDevices.site': 'Site',
  'settings.hr.clockDevices.sitePlaceholder': 'Choose a site that runs gate sign-in',
  'settings.hr.clockDevices.noGatedSites': 'No site runs gate sign-in yet. Turn it on on the Site first, then register its device here.',
  'settings.hr.clockDevices.label': 'Label',
  'settings.hr.clockDevices.kind': 'Kind',
  'settings.hr.clockDevices.registeredOn': 'registered',
  'settings.hr.clockDevices.by': 'by',
  'settings.hr.clockDevices.retire': 'Retire',
  'settings.hr.clockDevices.retireTitle': 'Retire this clock device?',
  'settings.hr.clockDevices.retireBody': 'The gate stops taking entries on it at once. The entries it already recorded keep naming it, and a new device can be registered in its place.',
  'settings.hr.clockDevices.retired': 'The device is retired. The gate takes no more entries on it.',
  'settings.hr.clockDevices.retiredPill': 'Retired',
  'settings.hr.clockDevices.problem.site': 'Choose the site the device stands at.',
  'settings.hr.clockDevices.problem.label': 'A device has a label.',
  'settings.hr.holidays.title': 'Holidays',
  'settings.hr.holidays.hint': 'The days the after-hours premium and the calendar treat as holidays. A removed holiday leaves the calendar on its next read.',
  'settings.hr.holidays.year': 'Year',
  'settings.hr.holidays.none': 'No holiday is listed for this year.',
  'settings.hr.holidays.add': 'Add a Holiday',
  'settings.hr.holidays.addTitle': 'Add a Holiday',
  'settings.hr.holidays.addAction': 'Add Holiday',
  'settings.hr.holidays.added': 'The holiday is added.',
  'settings.hr.holidays.name': 'Name',
  'settings.hr.holidays.date': 'Date',
  'settings.hr.holidays.observedTick': 'Observed on this day',
  'settings.hr.holidays.observedPill': 'Observed',
  'settings.hr.holidays.scope': 'Applies to',
  'settings.hr.holidays.scopeOrganisation': 'Organization-wide',
  'settings.hr.holidays.scopeState': '{state} only',
  'settings.hr.holidays.generate': 'Generate the Federal Set',
  'settings.hr.holidays.generated': '{count} holidays were added for {year}.',
  'settings.hr.holidays.generatedNone': 'Every federal holiday of {year} is already listed.',
  'settings.hr.holidays.remove': 'Remove',
  'settings.hr.holidays.removeTitle': 'Remove This Holiday',
  'settings.hr.holidays.removeBody': 'The holiday is removed, and the history keeps its name, its day and the reason you give.',
  'settings.hr.holidays.reason': 'Reason',
  'settings.hr.holidays.removed': 'The holiday is removed.',
  'settings.hr.holidays.problem.name': 'A holiday has a name.',
  'settings.hr.holidays.problem.date': 'Choose the day of the holiday.',
  'settings.hr.holidays.problem.reason': 'Removing a holiday names its reason.',
  'settings.hr.day.sunday': 'Sunday',
  'settings.hr.day.monday': 'Monday',
  'settings.hr.day.tuesday': 'Tuesday',
  'settings.hr.day.wednesday': 'Wednesday',
  'settings.hr.day.thursday': 'Thursday',
  'settings.hr.day.friday': 'Friday',
  'settings.hr.day.saturday': 'Saturday',
  'settings.hr.businessHours.title': 'Business Hours',
  'settings.hr.businessHours.hint': 'The hours the business is open. Work booked outside them, on a day with none, or on a holiday carries the after-hours premium. A change takes effect from the day you choose and leaves the earlier hours as they were.',
  'settings.hr.businessHours.noneSet': 'No business hours are set, so the after-hours premium applies on holidays alone. Set the hours to charge it on evenings and weekends too.',
  'settings.hr.businessHours.closed': 'Closed',
  'settings.hr.businessHours.period': '{opens} to {closes}',
  'settings.hr.businessHours.from': 'from {date}',
  'settings.hr.businessHours.until': 'until {date}',
  'settings.hr.businessHours.set': 'Set Hours',
  'settings.hr.businessHours.setTitle': 'Set Business Hours',
  'settings.hr.businessHours.save': 'Save Hours',
  'settings.hr.businessHours.days': 'Days',
  'settings.hr.businessHours.opens': 'Opens',
  'settings.hr.businessHours.closes': 'Closes',
  'settings.hr.businessHours.effectiveFrom': 'Takes effect',
  'settings.hr.businessHours.closedTick': 'Closed on these days',
  'settings.hr.businessHours.saved': 'The business hours are saved.',
  'settings.hr.businessHours.midnight': 'Midnight',
  'settings.hr.businessHours.problem.days': 'Choose at least one day.',
  'settings.hr.workweek.title': 'Workweek',
  'settings.hr.workweek.hint': 'When the 168-hour week that overtime is counted against begins. A change takes effect from the day you choose, never backwards, and its reason is kept on record.',
  'settings.hr.workweek.none': 'No workweek is defined yet.',
  'settings.hr.workweek.starts': '{day} at {time}',
  'settings.hr.workweek.change': 'Change the Workweek',
  'settings.hr.workweek.save': 'Save Workweek',
  'settings.hr.workweek.startDay': 'Week starts on',
  'settings.hr.workweek.startTime': 'At',
  'settings.hr.workweek.effectiveFrom': 'Takes effect',
  'settings.hr.workweek.saved': 'The workweek is changed.',
  'settings.hr.workweek.problem.reason': 'A workweek change names its reason.',
  'settings.hr.days.hint': 'How many days each HR reminder and deadline waits, such as how early an expiring certificate is flagged. A change applies from the moment it is saved, and the earlier numbers are kept on record.',
  'settings.hr.days.certificationLead': 'Certification expiry lead time',
  'settings.hr.days.certificationLeadHint': 'A renewal to-do is raised this many days before a certification lapses.',
  'settings.hr.days.retaliationGuard': 'Retaliation guard window',
  'settings.hr.days.retaliationGuardHint': 'Discipline, a pay change or a shift change for a complainant within this many days will be flagged for HR review. Recorded, not yet applied: nothing reads this number until its reader is built.',
  'settings.hr.days.acknowledgementReminder': 'Acknowledgement reminder',
  'settings.hr.days.acknowledgementReminderHint': 'An unacknowledged write-up will be reminded once after this many days, and HR told. Recorded, not yet applied: nothing reads this number until its reader is built.',
  'settings.hr.days.awaitingDeliveryStall': 'Awaiting delivery stall',
  'settings.hr.days.awaitingDeliveryStallHint': 'A write-up still awaiting delivery after this many days will appear on the stall queue. Recorded, not yet applied: nothing reads this number until its reader is built.',
  'settings.hr.days.absenceEscalation': 'Absence escalation timeout',
  'settings.hr.days.absenceEscalationHint': 'An absence nobody entered as time off will escalate after this many days. Recorded, not yet applied: nothing reads this number until its reader is built.',
  // Decision 12931 (T3856): the radius a gate punch may stand from the site's pin before the approver's queue says so.
  'settings.hr.punch.title': 'Punch Radius',
  'settings.hr.punch.hint': 'How far from the site’s pin a gate punch may stand before Time Awaiting Approval tells the approver how far it was. The punch is never refused, and no location is shown, only the distance.',
  'settings.hr.punch.field': 'Punch Radius In Meters',
  'settings.hr.punch.fieldHint': 'A whole number of meters from 50 to 50,000. A site with no pin is never flagged.',
  'settings.hr.substance.title': 'Substance Policy',
  'settings.hr.substance.hint': 'The written substance policy the handbook and Group 3 discipline cite. Nothing is filled in until you write it, and no drug test can be recorded until the procedure holds a line.',
  'settings.hr.substance.procedure': 'Testing procedure',
  'settings.hr.substance.procedureHint': 'One step a line: collection, chain of custody, confirmation testing, Medical Review Officer review.',
  'settings.hr.substance.consequences': 'Consequence table',
  'settings.hr.substance.consequencesHint': 'One row a line: the offense, a colon, then the consequence. For example, Refusing a test: treated as a confirmed positive result.',
  'settings.hr.substance.testingRule': 'When a test is asked for',
  'settings.hr.substance.testingRuleHint': 'One rule a line: pre-employment, reasonable suspicion, post-accident, random, return to duty, and any customer or regulatory rule.',
  'hr.claims.title': 'Unemployment Claims',
  'hr.claims.subtitle': 'Claims filed with a state about this job, each with its response deadline and contest packet',
  'hr.claims.open': 'Unemployment Claims',
  'hr.claims.back': 'Back to the Employee Page',
  'hr.claims.empty': 'No unemployment claim is recorded for this job.',
  'hr.claims.new': 'Record a Claim',
  'hr.claims.state': 'State',
  'hr.claims.claimDate': 'Notice date',
  'hr.claims.responseDueOn': 'Response deadline',
  'hr.claims.responseDueHint': 'The date on the state’s notice. Missing it forfeits the outcome with no hearing on the merits.',
  'hr.claims.save': 'Save',
  'hr.claims.record': 'Record Claim',
  'hr.claims.recorded': 'The claim is recorded.',
  'hr.claims.saved': 'The claim is saved.',
  'hr.claims.daysLeft': 'days left to respond',
  'hr.claims.overdue': 'The response deadline has passed with no decision.',
  'hr.claims.decision': 'Contest decision',
  'hr.claims.decision.undecided': 'Undecided',
  'hr.claims.decision.contest': 'Contest',
  'hr.claims.decision.doNotContest': 'Do Not Contest',
  'hr.claims.reason': 'Reason for the decision',
  'hr.claims.outcome': 'Outcome',
  'hr.claims.outcome.pending': 'Pending',
  'hr.claims.outcome.allowed': 'Allowed',
  'hr.claims.outcome.denied': 'Denied',
  'hr.claims.outcome.withdrawn': 'Withdrawn',
  'hr.claims.outcomeOn': 'Outcome date',
  'hr.claims.packet': 'Contest Packet',
  'hr.claims.packetEmpty': 'No packet file is uploaded yet.',
  'hr.claims.packetUpload': 'Upload to Packet',
  'hr.claims.packetUploaded': 'The file is added to the packet.',
  'hr.claims.enteredBy': 'Entered by',
  // Decision 13030: time off, requested on My Info and the phone's calendar, decided on Time Awaiting Approval.
  'hr.file.section.timeOff': 'Time Off',
  'hr.timeOff.request': 'Request Time Off',
  'hr.timeOff.title': 'Request Time Off',
  'hr.timeOff.act': 'Submit Request',
  'hr.timeOff.lead': 'Your manager decides the request. Weekends, days off and company holidays count no hours.',
  'hr.timeOff.plan': 'Plan',
  'hr.timeOff.choosePlan': 'Choose a plan',
  'hr.timeOff.firstDay': 'First Day',
  'hr.timeOff.lastDay': 'Last Day',
  'hr.timeOff.hours': 'Hours',
  'hr.timeOff.hoursHint': 'Leave it empty to count each working day in full, or write fewer hours for a part day.',
  'hr.timeOff.note': 'Note to Your Approver',
  'hr.timeOff.balances': 'Balances',
  'hr.timeOff.requests': 'Requests',
  'hr.timeOff.available': 'Available Balance',
  'hr.timeOff.pending': 'Pending',
  'hr.timeOff.requestable': 'You Can Request',
  'hr.timeOff.usedThisYear': 'Used This Year (Calendar Year)',
  'hr.timeOff.balanceLine': '{available} available · {pending} pending · {requestable} you can request',
  'hr.timeOff.balanceHint': 'The balance is the hours earned to date. Time you will earn before the first day is not counted yet.',
  'hr.timeOff.usedLine': '{used} used this calendar year',
  'hr.timeOff.hoursUnit': 'hours',
  'hr.timeOff.noPlans': 'This job is not enrolled in a time-off plan yet, so no request can be made. HR enrolls a job in a plan.',
  'hr.timeOff.noJob': 'You hold no job at the organization’s own company, so there is no time off to request.',
  'hr.timeOff.submitted': 'Your request is sent to your manager.',
  'hr.timeOff.cancel': 'Cancel Request',
  'hr.timeOff.cancelTitle': 'Cancel This Request',
  'hr.timeOff.cancelConfirm': 'Approved time comes back to your balance and leaves your calendar. A pending request is withdrawn.',
  'hr.timeOff.cancelled': 'The request is canceled.',
  'hr.timeOff.rejectedBecause': 'Not approved: {reason}',
  'hr.timeOff.decidedBy': 'decided by {name}',
  'hr.timeOff.eventSubject': 'Time Off',
  'hr.timeOff.status.pending': 'Pending',
  'hr.timeOff.status.approved': 'Approved',
  'hr.timeOff.status.rejected': 'Rejected',
  'hr.timeOff.status.cancelled': 'Canceled',
  'hr.timeOff.problem.plan': 'Choose the plan the time comes from.',
  'hr.timeOff.problem.day': 'Write the day as a real calendar day.',
  'hr.timeOff.problem.past': 'Time off starts today or later.',
  'hr.timeOff.problem.order': 'The last day falls on or after the first day.',
  'hr.timeOff.problem.long': 'One request covers a year at most.',
  'hr.timeOff.problem.hours': 'Write the hours as a quarter hour or more, with two places at most.',
  'hr.timeOff.problem.tooMany': 'The hours are more than the days of the request hold.',
  'hr.timeOff.problem.overCounted': 'These days count {counted} hours, so write {counted} hours or fewer for a part day.',
  'hr.timeOff.problem.dayCountsNone': '{day} is a weekend, a day off or a company holiday, so it counts no hours; choose a day you work.',
  'hr.timeOff.problem.daysCountNone': 'Every day of this request is a weekend, a day off or a company holiday, so it counts no hours; choose days you work.',
  'hr.timeOff.problem.note': 'The note is 500 characters at most.',
  // Decision 13251: HR cancels the unused days of an approved request that has begun.
  'hr.timeOffBegun.heading': 'Time Off Under Way',
  'hr.timeOffBegun.cancel': 'Cancel Remaining Days',
  'hr.timeOffBegun.title': 'Cancel the Remaining Days',
  'hr.timeOffBegun.hint': 'The days after today leave the person’s calendar and their hours come back to the balance. The days already taken stay taken.',
  'hr.timeOffBegun.reason': 'Reason',
  'hr.timeOffBegun.line': '{span} · {hours} · {returned} come back if canceled',
  'hr.timeOffBegun.done': 'The remaining days are canceled and {hours} come back to the balance.',
  'hr.timeOffApproval.heading': 'Time Off Requests',
  'hr.timeOffApproval.subtitle': 'The time off of the people under you, and the team’s days around it',
  'hr.timeOffApproval.hint': 'Each request shows who on the team is off on its days. Approving puts the time on the person’s calendar and emails them.',
  'hr.timeOffApproval.empty': 'No time-off request waits on you.',
  'hr.timeOffApproval.approve': 'Approve',
  'hr.timeOffApproval.reject': 'Reject',
  'hr.timeOffApproval.rejectTitle': 'Reject Time Off',
  'hr.timeOffApproval.reason': 'Reason',
  'hr.timeOffApproval.reasonHint': 'The person reads this reason in the email and on My Info.',
  'hr.timeOffApproval.own': 'Your own request is decided by the manager above you.',
  'hr.timeOffApproval.balance': '{requestable} they can request · {after} left after this request',
  'hr.timeOffApproval.dayOff': 'Counts no hours',
  'hr.timeOffApproval.off': 'Off: {names}',
  'hr.timeOffApproval.pendingOff': 'Pending: {names}',
  'hr.timeOffApproval.nobodyOff': 'Nobody else on the team is off',
  'hr.timeOffApproval.left': '{left} of {team} at work',
  'hr.timeOffApproval.approved': '{name}’s time off is approved and on their calendar.',
  'hr.timeOffApproval.rejected': '{name}’s time off is rejected, with your reason.',
  // Decision 13130 (T3904): the Job section's time-off plans, Enroll and End, and Settings › HR › Time Off Plans.
  'hr.timeOffPlans.heading': 'Time Off Plans',
  'hr.timeOffPlans.ended': 'Ended',
  'hr.timeOffPlans.enroll': 'Enroll in a Plan',
  'hr.timeOffPlans.enrollTitle': 'Enroll in a Time Off Plan',
  'hr.timeOffPlans.enrollAct': 'Enroll',
  'hr.timeOffPlans.enrollLead': 'The opening balance becomes the first row of the plan’s ledger. Nobody edits it afterwards, so check the figure before you enroll.',
  'hr.timeOffPlans.everyPlan': 'This job is enrolled in every active plan.',
  'hr.timeOffPlans.endedJob': 'This job has ended, so it takes no new plan.',
  'hr.timeOffPlans.plan': 'Plan',
  'hr.timeOffPlans.choosePlan': 'Choose a plan',
  'hr.timeOffPlans.startDate': 'Enrolled From',
  'hr.timeOffPlans.openingHours': 'Opening Balance (Hours)',
  'hr.timeOffPlans.openingHint': 'The hours the person has to spend on the first day. Write 0 for a new hire.',
  'hr.timeOffPlans.reason': 'Reason',
  'hr.timeOffPlans.reasonHint': 'Why the job joins the plan, such as a new hire or a balance carried over.',
  'hr.timeOffPlans.enrolled': 'The job is enrolled and its opening balance is on the ledger.',
  'hr.timeOffPlans.end': 'End',
  'hr.timeOffPlans.endTitle': 'End This Plan',
  'hr.timeOffPlans.endAct': 'End Plan',
  'hr.timeOffPlans.endLead': 'The balance stays on the ledger. No request starting after the last day is offered this plan.',
  'hr.timeOffPlans.endDate': 'Last Day in the Plan',
  'hr.timeOffPlans.endedSaved': 'The plan is ended for this job.',
  'hr.timeOffPlans.problem.plan': 'Choose the plan the job joins.',
  'hr.timeOffPlans.problem.beforeJob': 'The job starts on {day}, so the enrollment starts then or later.',
  'hr.timeOffPlans.problem.afterJob': 'The job ends on {day}, so the enrollment starts then or earlier.',
  'hr.timeOffPlans.problem.opening': 'Write the opening balance as 0 to 99,999.99 hours, with two places at most.',
  'hr.timeOffPlans.problem.openingTotal': 'The balance after this opening balance would pass 99,999.99 hours. Write a smaller opening balance.',
  'hr.timeOffPlans.problem.reason': 'Write why the job joins the plan, in 200 characters at most.',
  'hr.timeOffPlans.problem.endBeforeStart': 'The enrollment starts on {day}, so its last day falls then or later.',
  'hr.timeOffPlans.problem.name': 'Write the plan’s name, in 80 characters at most.',
  'hr.timeOffPlans.problem.period': 'Choose how often the plan accrues.',
  'hr.timeOffPlans.problem.basis': 'Choose what the plan’s accrual is measured on.',
  'hr.timeOffPlans.problem.cap': 'Write the cap as a multiple above 0 and up to 999.99, with two places at most, or leave it empty for no cap.',
  'hr.timeOffPlans.problem.waiting': 'Write the waiting period as a whole number of days from 0 to 3,650.',
  'hr.timeOffPlans.problem.increment': 'Write the smallest request as 0.25 to 24 hours, with two places at most.',
  'settings.timeOffPlans.title': 'Time Off Plans',
  'settings.timeOffPlans.hint': 'Each leave plan the company offers and how it accrues. An edit reaches no ledger row already written; each row keeps the rule it was written under. Plans are not added here.',
  'settings.timeOffPlans.empty': 'No time-off plan is on file.',
  'settings.timeOffPlans.editTitle': 'Edit Time Off Plan',
  'settings.timeOffPlans.inactive': 'Not Active',
  'settings.timeOffPlans.active': 'Active',
  'settings.timeOffPlans.name': 'Name',
  'settings.timeOffPlans.kind': 'Kind',
  'settings.timeOffPlans.period': 'Accrues',
  'settings.timeOffPlans.basis': 'Measured On',
  'settings.timeOffPlans.cap': 'Cap (Times the Annual Rate)',
  'settings.timeOffPlans.capHint': 'Leave it empty for no cap. Accrual stops at the cap and resumes when time is taken.',
  'settings.timeOffPlans.noCap': 'No cap',
  'settings.timeOffPlans.capLine': 'Capped at {cap} times the annual rate',
  'settings.timeOffPlans.waiting': 'Waiting Period (Days)',
  'settings.timeOffPlans.waitingLine': '{days}-day wait',
  'settings.timeOffPlans.increment': 'Smallest Request (Hours)',
  'settings.timeOffPlans.incrementLine': '{hours}-hour smallest request',
  'settings.timeOffPlans.negative': 'Allow a Negative Balance',
  'settings.timeOffPlans.negativeLine': 'Negative balance allowed',
  'settings.timeOffPlans.payout': 'Paid Out at Separation',
  'settings.timeOffPlans.payoutLine': 'Paid out at separation',
  'settings.timeOffPlans.readOnly': 'The kind, the active state and the dates are not edited here.',
  'settings.timeOffPlans.kind.vacation': 'Vacation',
  'settings.timeOffPlans.kind.sick': 'Sick',
  'settings.timeOffPlans.kind.personal': 'Personal',
  'settings.timeOffPlans.kind.bereavement': 'Bereavement',
  'settings.timeOffPlans.kind.unpaid': 'Unpaid',
  'settings.timeOffPlans.period.perPayPeriod': 'Each Pay Period',
  'settings.timeOffPlans.period.monthly': 'Monthly',
  'settings.timeOffPlans.period.annualGrant': 'Once a Year',
  'settings.timeOffPlans.basis.tenure': 'Tenure',
  'settings.timeOffPlans.basis.flat': 'Flat Rate',
  'settings.timeOffPlans.basis.perHourWorked': 'Hours Worked',
} as const;
